import { classNames } from '@allurion/ui';
import { Suspense } from 'react';

import { InlineLoader } from './InlineLoader';

import styles from './Sidebar.module.scss';

type Props = {
  isOpen: boolean;
  children?: React.ReactNode;
  offcanvas?: boolean;
};

export function Sidebar({ isOpen, children, offcanvas }: Props) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className={classNames(styles.sidebar, offcanvas && styles.offcanvas)}>
      <Suspense fallback={<InlineLoader />}>{children}</Suspense>
    </div>
  );
}
